import Link from 'next/link'
import { FC } from 'react'

import { ShowAllBlockCustom } from '@/shared/ui/ShowAllBlockCustom'

import cl from './CreditNotesBlock.module.scss'

export const CreditNotesBlock: FC = () => {
	return (
		<section className={cl.creditNotes}>
			<ShowAllBlockCustom buttonText={{ activeText: 'Скрыть', defaultText: 'Показать полностью' }}>
				«Рассрочка» и «Рассрочка с картой преимуществ iPort+» — рекламная акция, в рамках которой организатор акции
				предоставляет скидки на приобретение товаров при условии, что такие товары приобретаются в кредит, оформляемый в
				одном из Банков-партнёров. Банк-партнёр самостоятельно принимает решение о предоставлении либо отказе в
				предоставлении кредита без объяснения причин.
				<br />
				Кредит предоставляется Банками-партнёрами:
				<br />
				ООО «Хоум Кредит энд Финанс Банк». Генеральная лицензия Банка России № 316 от 15.03.2012 г.
				<br />
				АО «Кредит Европа Банк». Генеральная лицензия Банка России № 3311 от 023.05.1997 г.
				<br />
				ПАО «Совкомбанк». Генеральная лицензия Банка России № 963 от 27.11.1990г. <br />
				АО «Тинькофф Банк». Лицензия Центрального Банка № 2673 от 24.03.2015 г. <br />
				ПАО «МТС-Банк». Генеральная лицензия Банка России № 2268 от 17.12.2014 г. <br />
				КБ «Ренессанс Кредит» Генеральная лицензия Банка России № 3354 от 24.11.2000 <br />
				Оформление кредита on-line или в магазинах осуществляется ООО “Всегда Да”
				<br />
				Оплата покупки в магазине или on-line возможна по карте рассрочки “Халва”. Условия приобретения товара в
				рассрочку: 3 месяца беспроцентной рассрочки на товар.
			</ShowAllBlockCustom>
			<ShowAllBlockCustom buttonText={{ activeText: 'Скрыть', defaultText: 'Показать полностью' }}>
				При единовременной покупке техники Apple с картой преимуществ в рамках акции «Рассрочка с картой преимуществ
				iPort+» ({` `}
				<Link prefetch={false} href="/catalog/apple_iphone/">
					iPhone
				</Link>
				,{` `}
				<Link prefetch={false} href="/catalog/apple_ipad/">
					iPad
				</Link>
				,{` `}с одной из карт iPort+ Gold new/Care/Platinum, для {` `}
				<Link prefetch={false} href="/catalog/apple_mac/">
					Mac
				</Link>
				{` `} с картой iPort + Black, для {` `},
				<Link prefetch={false} href="/catalog/apple_watch/">
					Apple Watch
				</Link>
				{` `}с картой iPort+ Watch ) возможно увеличение максимального срока кредита, действующего в рамках акции
				«Рассрочка».Список товаров, на которые действуют акции «Рассрочка» и «Рассрочка с картой преимуществ iPort+»,
				ограничен. При единовременной покупке двух и более товаров в рамках акции «Рассрочка» и «Рассрочка с картой
				преимуществ iPort+», срок кредита рассчитывается как наименьший из доступных для товаров в чеке. Все товары,
				участвующие в акции, сертифицированы. Скидка по акциям «Рассрочка» и «Рассрочка с картой преимуществ iPort+»
				предоставляется от цен, указанных без учёта скидок. Совмещение скидки по акциям «Рассрочка» и «Рассрочка с
				картой преимуществ iPort+» с любыми иными видами и классами скидок не допускается. Акция «Рассрочка» действует
				во всех розничных магазинах сети и интернет-магазине iPort.ru. Акция «Рассрочка с картой преимуществ iPort+»
				действует во всех розничных магазинах сети. В интернет-магазине iPort.ru акция не действует. Срок действия
				акций: 01.10.2018 – 31.12.2023. Условия предоставления рассрочки (размер первоначального взноса, срок кредита, а
				также объём средств, предоставляемых в кредит) определяются индивидуально для каждого клиента. Подробности о
				рассрочке и условиях её предоставления уточняйте у продавцов-консультантов в магазинах iPort и менеджеров
				интернет-магазина iPort.ru. Организатор предложения и продавец товара iPort - ООО «Портативная техника» (юр.
				адрес:190031, Санкт-Петербург, наб. реки Фонтанки, д.109, литер А, ОГРН № 1057811930296). Ставка от 9.28% до
				21.6% (рассрочка предоставляется с небольшим удорожанием, за счёт скидки продавца от 3.5% до 12% от стоимости
				товара. Общая сумма переплаты за рассрочку может составлять от 1% до 10%, в зависимости от предложения.
			</ShowAllBlockCustom>
		</section>
	)
}
